import { AbstractControl, Validators } from "@angular/forms";

import { OBG_VALIDATORS } from "./validators";

export function zhhBettingLimitValidator(control: AbstractControl) {
	const LOGIN_LIMIT_MIN_VALUE = 10;
	const LOGIN_LIMIT_MAX_VALUE = 999999999999;

	return (
		Validators.required(control) ||
		OBG_VALIDATORS.numericNotZero(control) ||
		OBG_VALIDATORS.numberSmallerOrEqual(LOGIN_LIMIT_MAX_VALUE)(control) ||
		OBG_VALIDATORS.numberBiggerOrEqual(LOGIN_LIMIT_MIN_VALUE)(control)
	);
}
